import { RedoProduct } from "@redotech/redo-common-model/redo-product";
import * as z from "zod";

/**
 * Gen II `Integration` kinds queryable for connected status (input whitelist);
 * extend only when a registry entry adopts a `gen2Kind` status source.
 */
export const gen2StatusKinds = [
  "Adyen",
  "Aims360",
  "AmazonSellingPartners",
  "ApparelMagic",
  "Aptos",
  "Attentive",
  "Bigcommerce",
  "Brightpearl",
  "CanadaPostCarrierAccount",
  "CanadaPostDeveloperPortalCarrierAccount",
  "ChitChatsCarrierAccount",
  "Cin7Core",
  "Cin7Omni",
  "Commentsold",
  "CommerceCloud",
  "DhlEcommerceDirectCarrierAccount",
  "Easypost",
  "Ebay",
  "Facebook",
  "Faire",
  "Falcon",
  "FedExCarrierAccount",
  "Finale",
  "GlobalE",
  "Gmail",
  "GoogleAds",
  "GoogleMerchantCenter",
  "Gorgias",
  "Growave",
  "HappyReturns",
  "Instagram",
  "Kustomer",
  "LandmarkGlobal",
  "LinnworksDirect",
  "Linx",
  "Liquidonate",
  "MetaAds",
  "NetSuite",
  "Okendo",
  "OkendoMarketing",
  "Oms-ApparelMagic",
  "Oms-NetSuite",
  "Optty",
  "OrdersApi",
  "Outlook",
  "ParentEasypost",
  "PayPal",
  "Postscript",
  "Recharge",
  "Richpanel",
  "Rithum",
  "Rokt",
  "SendcloudCarrierAccount",
  "SendcloudCarrierContract",
  "ShipStationApi",
  "Skio",
  "SpsCommerce",
  "StallionExpressCarrierAccount",
  "StayAi",
  "Stripe",
  "Tiktok",
  "TiktokAds",
  "Trackstar",
  "UniUniCarrierAccount",
  "UnifiedTemu",
  "UnifiedTiktok",
  "Uptick",
  "UpsGhostAccountIntegration",
  "UspsCarrierAccount",
  "Walmart",
  "Wayfair",
  "WooCommerce",
] as const;

export type Gen2StatusKind = (typeof gen2StatusKinds)[number];

/**
 * RedoProduct subset a Gen II doc can report per-product activation for;
 * only kinds whose schema carries real per-product flags ever populate this.
 */
export const gen2ActiveProducts = [
  RedoProduct.CONVERSION,
  RedoProduct.MARKETING,
  RedoProduct.OMS,
  RedoProduct.RETURNS,
  RedoProduct.SUPPORT,
] as const;

export type Gen2ActiveProduct = (typeof gen2ActiveProducts)[number];

const integrationStatusSchema = z.object({
  isConnected: z.boolean(),
  activeProducts: z.array(z.enum(gen2ActiveProducts)).optional(),
});

export const getGen2IntegrationStatuses = {
  name: "getGen2IntegrationStatuses" as const,
  /** Unknown kinds are accepted and ignored so old/new client-server pairs coexist during deploys. */
  input: z.object({ kinds: z.array(z.string()) }),
  output: z.partialRecord(z.enum(gen2StatusKinds), integrationStatusSchema),
};
